import { Icon } from "@mux/ui/icon";
import { A } from "@solidjs/router";
import { workspaceReturnRoute } from "@/context/workspace-return-route";

/**
 * Returns to the workspace route the user left to open a control page
 * (Settings, Providers, Tools) instead of the dashboard root.
 */
export function ControlPageBack(props: { label?: string; class?: string }) {
  return (
    <A
      href={workspaceReturnRoute()}
      class={`-ml-1.5 flex w-fit items-center gap-1 rounded-md px-1.5 text-text-weak transition-colors hover:bg-surface-raised-base hover:text-text-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus ${props.class ?? "h-7 text-12-medium"}`}
      aria-label={`Back to ${props.label ?? "app"}`}
    >
      <Icon name="chevron-left" size="small" />
      <span>{props.label ?? "Back"}</span>
    </A>
  );
}

/** Mobile-only variant for pages whose desktop navigation lives in the titlebar. */
export function MobileControlPageBack() {
  return <ControlPageBack label="Chats" class="mb-5 min-h-11 text-14-medium md:hidden" />;
}
